import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrgChartComponent } from './org-chart/org-chart.component';
import { EmployeeComponent } from './employee/employee.component';
export class OrgChartModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
	imports: [
		CommonModule
	],
	declarations: [OrgChartComponent, EmployeeComponent],
	exports: [OrgChartComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function OrgChartModule_tsickle_Closure_declarations() {
/** @type {?} */
OrgChartModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OrgChartModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
